<template>
  <!-- 合作联系 -->
  <div class="linkWrapper">
    <div v-wechat-title="$route.meta.title" />
    <div class="wrap_flex">
      <div class="wrap_con">
        <div v-if="language === 'zh'" class="gl_cont">
          <div class="tc">
            <img src="https://static.mingchu.co/webapp/active/position.jpg" class="map_a" alt="">
          </div>
          <!-- 				<dl class="gl_txt_list">
              <dt>联系方式</dt>
              <dd>地址：北京市朝阳区霄云路40号国航世纪大厦4层</dd>
              <dd>邮编：100027</dd>
              <dd>电话：010－8090 8439</dd>
              {{--<dd>传真：010－590 090 49 </dd>--}}
            </dl> -->
          <!-- <div class="gl_line"></div> -->
          <dl class="gl_txt_list">
            <dt>业务合作</dt>
            <!-- <dd>地      址：中国北京市东城区隆福寺街 95 号 1 号楼 WeWork 1 层</dd> -->
            <dd>地      址：北京市朝阳区东风南路8号东枫德必WE-E栋2层206室</dd>
            <dd>总      机：<a href="tel:01021737273">010－2173 7273 </a> </dd>
            <dd>邮      箱：<a href="mailto:nihao@mingchu.co">nihao@mingchu.co</a>
            </dd>
            <!-- <dd>服务时间：欢迎随时联系 </dd> -->
          </dl>
          <div class="gl_line" />
          <dl class="gl_txt_list">
            <dt>业务合作</dt>
            <dd>邮      箱：<a href="mailto:hello@mingchu.co">hello@mingchu.co</a></dd>
            <dd>Facebook：<a href="https://www.facebook.com/mingchu.co">mingchu.co</a></dd>
            <dd>Instagram：<a href="https://www.instagram.com/mingchu.co">mingchu.co</a></dd>
            <!-- <dd>服务时间：欢迎随时联系 </dd> -->
          </dl>
        </div>
        <div v-if="language === 'fn'" class="gl_cont">
          <div class="tc">
            <img src="https://static.mingchu.co/webapp/active/position.jpg" class="map_a" alt="">
          </div>
          <!-- 				<dl class="gl_txt_list">
              <dt>中國大陸聯系方式</dt>
              <dd>地址：北京市朝陽區霄雲路40號國航世紀大廈4層</dd>
              <dd>郵編：100027</dd>
              <dd>電話：010－8090 8438</dd>
            </dl>
            <div class="gl_line"></div> -->
          <dl class="gl_txt_list">
            <dt>相關合作洽談</dt>
            <dd>地址：110 台北市信義區松仁路 97 號 WeWork 17 樓 121 室</dd>
            <dd>Mail：<a href="mailto:hello@mingchu.co">hello@mingchu.co</a></dd>
            <dd>Facebook：<a href="https://www.facebook.com/mingchu.co">mingchu.co</a></dd>
            <dd>Instagram：<a href="https://www.instagram.com/mingchu.co">mingchu.co</a></dd>
            <!-- <dd>服務時間：歡迎隨時聯系，我們會儘快回覆，謝謝！ </dd> -->
          </dl>
          <div class="gl_line" />
          <dl class="gl_txt_list">
            <dt>中國大陸業務合作</dt>
            <dd>地址：北京市朝阳区东风南路8号东枫德必WE-E栋2层206室</dd>
            <dd>電話：<a href="tel:+86 01021737273">+86-010－2173 7273 </a> </dd>
            <dd>Mail：<a href="mailto:nihao@mingchu.co">nihao@mingchu.co</a></dd>
            <!-- <dd>服務時間：歡迎隨時聯系，我們會儘快回覆，謝謝！ </dd> -->
          </dl>
        </div>
        <div v-if="language === 'en'" class="gl_cont">
          <div class="tc">
            <img src="https://static.mingchu.co/webapp/active/position.jpg" class="map_a" alt="">
          </div>
          <!-- 				<dl class="gl_txt_list">
              <dt>Contact us</dt>
              <dd>Address: Beijing Chaoyang District, no 40 Xiaoyun Street, 4F Air China Century Building</dd>
              <dd>Email: 100027</dd>
              <dd>Phone: 010-8090 8439</dd>
            </dl>
            <div class="gl_line"></div> -->
          <dl class="gl_txt_list">
            <dt>Business Cooperation</dt>
            <!-- <dd>Address: No. 95 Long Fu Si Street Building 1 WeWork Floor 1 Dongcheng District Beijing China</dd> -->
            <dd>Address: Dongfengdebi WE, Block E, 2/F, Room 206, Dongfeng South Road No.8, Chaoyang Beijing China</dd>
            <dd>Phone: <a href="tel:+86 01021737273">+86-010－2173 7273 </a> </dd>
            <dd>Email: <a href="mailto:nihao@mingchu.co">nihao@mingchu.co</a></dd>
            <!-- <dd>Please feel free to contact us.</dd> -->
          </dl>
          <div class="gl_line" />
          <dl class="gl_txt_list">
            <dt>International Cooperation</dt>
            <dd>Email: <a href="mailto:hello@mingchu.co">hello@mingchu.co</a></dd>
            <dd>Facebook：<a href="https://www.facebook.com/mingchu.co">mingchu.co</a></dd>
            <dd>Instagram：<a href="https://www.instagram.com/mingchu.co">mingchu.co</a></dd>
            <!-- <dd>Please feel free to contact us.</dd> -->
          </dl>
        </div>
      </div>
      <div class="foot">
        <img src="https://static.mingchu.co/other/foot.png" alt="" class="gl_foot">
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils'
export default {
  props: {},
  data() {
    return {
      language: ''
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    function checkLang($lang) { // 先判断url上有没有参
      switch ($lang) { // 1-中文  2-繁体  3-英文
        case '2':
          return 'fn'
        case '3':
          return 'en'
        default: return 'zh'
      }
    }
    if (urlParams.get('lang_id')) {
      this.language = checkLang(urlParams.get('lang_id'))
    } else {
      this.language = utils.browserLanguage()
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.map_a{ height: 16.56rem !important; }
a{color: #C99700;}
</style>
